module.exports = __webpack_public_path__ + "static/media/dublin.5bcc921a.png";